import { render, staticRenderFns } from "./StaffGiftCards.vue?vue&type=template&id=f76069a6&scoped=true"
import script from "./StaffGiftCards.vue?vue&type=script&lang=js"
export * from "./StaffGiftCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76069a6",
  null
  
)

export default component.exports